var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error',{attrs:{"name":'500',"desc":'抱歉，服务器出错了'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }